import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  GrnDetail: [],
  BufferObj: {
     B_Srno: 0// int
    , B_RefDocTyp: ""
    , B_RefDocTypName: ""
    , B_RefDocNo: ""
    , B_Itmcd: ""
    , B_ItmName: ""
    , B_Barcode: ""
    , B_Qty: 0//Decimal
    , B_Unit: ""
    , B_UnitName: ""
    , B_PackQty: 0//Decimal
    , B_BaseQty: 0//Decimal
    , B_URateFc: 0//Decimal
    , B_URateLc: 0//Decimal
    , B_GrossAmt: 0//Decimal
    , B_LDiscPerc: 0//Decimal
    , B_LDiscAmt: 0//Decimal
    , B_TDiscPerc: 0//Decimal
    , B_TDiscAmt: 0//Decimal
    , B_FocFlag: "N"
    , B_AprmtFlag: ""
    , B_FocAmt: 0//Decimal
    , B_ExciseTaxAmt: 0//Decimal
    , B_ExciseTaxNetAmt: 0//Decimal
    , B_Taxable: 0//Decimal
    , B_Base_Rate: 0 //Decimal
    , B_TaxDept: ""
    , B_TaxPerc: 0//Decimal
    , B_TaxAmt: 0//Decimal
    , B_TaxDept2: ""
    , B_TaxPerc2: 0//Decimal
    , B_TaxAmt2: 0//Decimal
    , B_Ad_CessAmt: 0//Decimal
    , B_Ad_PCQty: 0//Decimal
    , B_Ad_PCRate: 0//Decimal
    , B_Ad_NetCessAmt: 0//Decimal
    , B_Total: 0//Decimal
    , B_HSN: ""
    , B_HighCost: "N"
    , B_PR: "N"
    , B_ExpDt: new Date()
    , B_Narr: ""
    , B_X_URateLc: 0//Decimal
    , B_X_DiffAmt: 0//Decimal
    , B_X_NetDiffAmt: 0//Decimal
    , Field6: ""
    , Field7: "N"
    , SplDiscAmt2: ""
    , SplDiscAmt3: 0
    , SplDiscAmt1: 0
    , Field8: ""

  }
}


const SliceGRNDetail = createSlice({
  name: "SliceGRNDetail",
  initialState: { value: initialState },

  reducers: {
    GrnDetail_Set: (state, action) => {
      state.value.GrnDetail = action.payload.GrnDetail;
    },

    GrnDetail_Init: (state) => {
      state.value.GrnDetail = initialState.GrnDetail;
    },

    BufferObj_Init: (state, action) => {
      state.value.BufferObj = initialState.BufferObj;
    },

    BufferObj_SetValue_Obj: (state, action) => {
      state.value.BufferObj = action.payload.BufferObj;
    },

    BufferObj_SetValue_Qty: (state, action) => {
      state.value.BufferObj.B_Qty = action.payload.B_Qty;
    },
    BufferObj_SetValue_SNO: (state, action) => {
      state.value.BufferObj.B_Srno = action.payload.B_Srno;
    },

    BufferObj_SetValue_ItemName: (state, action) => {
      state.value.BufferObj.B_Itmcd = action.payload.B_Itmcd;
      state.value.BufferObj.B_ItmName = action.payload.B_ItmName;
      state.value.BufferObj.B_Barcode = action.payload.B_Barcode;
    },

    BufferObj_SetValue_ItemNameTxt: (state, action) => {
      state.value.BufferObj.B_ItmName = action.payload.B_ItmName;
    },

    BufferObj_SetValue_Unit: (state, action) => {
      state.value.BufferObj.B_Unit = action.payload.B_Unit;
      state.value.BufferObj.B_UnitName = action.payload.B_UnitName;
      state.value.BufferObj.B_PackQty = action.payload.B_PackQty;
      // state.value.BufferObj.B_BaseQty = action.payload.B_BaseQty;
    },    

    BufferObj_SetValue_UnitRate: (state, action) => {
      state.value.BufferObj.B_URateFc = action.payload.B_URateFc;
    },

    BufferObj_SetValue_Foc: (state, action) => {
      state.value.BufferObj.B_FocFlag = action.payload.B_FocFlag;
    },

    BufferObj_SetValue_FocFlag: (state, action) => {
      state.value.BufferObj.B_AprmtFlag = action.payload.B_AprmtFlag;
    },

    BufferObj_SetValue_Excise: (state, action) => {
      state.value.BufferObj.B_ExciseTaxAmt = action.payload.B_ExciseTaxAmt;
    },

    BufferObj_SetValue_NetExcise: (state, action) => {
      state.value.BufferObj.B_ExciseTaxNetAmt = action.payload.B_ExciseTaxNetAmt;
    },
    BufferObj_SetValue_TaxGroup: (state, action) => {
      state.value.BufferObj.B_TaxDept = action.payload.B_TaxDept;
      state.value.BufferObj.B_TaxPerc = action.payload.B_TaxPerc;
    },
    BufferObj_SetValue_CessGroup: (state, action) => {
      state.value.BufferObj.B_TaxDept2 = action.payload.B_TaxDept2;
      state.value.BufferObj.B_TaxPerc2 = action.payload.B_TaxPerc2;
    },
    BufferObj_SetValue_Type: (state, action) => {
      state.value.BufferObj.Field6 = action.payload.Field6;
    },
    BufferObj_SetValue_ReduceCost: (state, action) => {
      state.value.BufferObj.Field7 = action.payload.Field7;
    },
    BufferObj_SetValue_Narration: (state, action) => {
      state.value.BufferObj.Field8 = action.payload.Field8;
    },
   
    BufferObj_SetValue_AddCess: (state, action) => {
      state.value.BufferObj.B_Ad_PCRate = action.payload.B_Ad_PCRate;
    },
   
    BufferObj_SetValue_LinewiseRebate: (state, action) => {
      state.value.BufferObj.Field6 = action.payload.Field6;
      state.value.BufferObj.SplDiscAmt2 = action.payload.SplDiscAmt2;
      state.value.BufferObj.SplDiscAmt3 = action.payload.SplDiscAmt3;
    },
    BufferObj_SetValue_BaseQty_Cal: (state, action) => {
      state.value.BufferObj.B_BaseQty = action.payload.B_BaseQty;
    },
    // let vBURateFc = fcovertToNumber(vRdxGRNDetail.B_URateFc) * fcovertToNumber(vRdxGRNHead.A_ExRate);
    //     let vBGrossAmt = fcovertToNumber(vRdxGRNDetail.B_Qty) * fcovertToNumber(vRdxGRNDetail.B_URateLc);
    //     let vBLDiscAmt = fcovertToNumber(vRdxGRNDetail.B_LDiscPerc/100) * vBGrossAmt;
    //     let vTDiscAmt = fcovertToNumber(vRdxGRNDetail.B_TDiscPerc/100) * (vBGrossAmt-vBLDiscAmt);
    //     let vBFocAmt = 0;
    //     let vNetExciseTaxAmt = fcovertToNumber(vRdxGRNDetail.B_Qty) * fcovertToNumber(vRdxGRNDetail.B_ExciseTaxAmt);
    //     let vBTaxable = vBGrossAmt- vBLDiscAmt - vTDiscAmt - vBFocAmt + vNetExciseTaxAmt;
       
    BufferObj_SetValue_Taxable_Cal: (state, action) => {
      state.value.BufferObj.B_URateLc = action.payload.B_URateLc;
      state.value.BufferObj.B_GrossAmt = action.payload.B_GrossAmt;
      state.value.BufferObj.B_LDiscAmt = action.payload.B_LDiscAmt;
      state.value.BufferObj.B_TDiscAmt = action.payload.B_TDiscAmt;
      state.value.BufferObj.B_FocAmt = action.payload.B_FocAmt;
      state.value.BufferObj.B_ExciseTaxNetAmt = action.payload.B_ExciseTaxNetAmt;
      state.value.BufferObj.B_Taxable = action.payload.B_Taxable;
    },
  },
});

export const {
  GrnDetail_Set,
  GrnDetail_Init,
  BufferObj_Init,
  BufferObj_SetValue_Obj,
  BufferObj_SetValue_ItemName,
  BufferObj_SetValue_ItemNameTxt,
  BufferObj_SetValue_Qty,
  BufferObj_SetValue_Unit,
  BufferObj_SetValue_UnitRate,
  BufferObj_SetValue_Foc,
  BufferObj_SetValue_FocFlag,
  BufferObj_SetValue_Excise,
  BufferObj_SetValue_NetExcise,
  BufferObj_SetValue_TaxGroup,
  BufferObj_SetValue_CessGroup,
  BufferObj_SetValue_Type,
  BufferObj_SetValue_ReduceCost,
  BufferObj_SetValue_Narration,
  BufferObj_SetValue_AddCess,
  BufferObj_SetValue_LinewiseRebate,
  BufferObj_SetValue_SNO,
  BufferObj_SetValue_BaseQty_Cal,
  BufferObj_SetValue_Taxable_Cal
} = SliceGRNDetail.actions;
export default SliceGRNDetail.reducer;
